export const trimText = (text, maxChars = 120) => {
  if (!text) return text
  return text.length > maxChars ? text.slice(0, maxChars) : text
}
